import { writable } from 'svelte/store';

import { db } from '../firestore';

function createTenantStore() {
	const { subscribe, set, update } = writable(null);

	return {
		subscribe,
		setViaTid: async (tid) => {
            console.log('Start of currentTenant.setViaTid:', tid);
            if(tid == null){
                set({
                    tid: null,
                    displayName: null
                })
                return;
                // firebase.auth().signOut().then(async function() {
                //     // Sign-out successful.
                //     // We don't have to update the currentUser object manually, because the UserObserver will do that automatically!
                //     console.log('Logged out.');
                //     await tick();
                //     //createLoginButton();
                // }).catch(function(error) {
                //     // An error happened.
                //     alert(error);
                // });
            }

            // Load tenant profile from Firebase
            let tenantDoc = await db.collection('tenants').doc(tid).get();
            let tenantProfile = await tenantDoc.data();

            // Set the data
            set({
                tid: tid,
                displayName: tenantProfile.displayName,
                //team: tenantProfile.team,
                //tenantProfile: tenantProfile // Full firebase document - just for reference
            });
        },
		reset: () => {
            set(undefined);
        }
	};
}

export const currentTenant = createTenantStore();